<template>
    <v-treeview :items="tree" transition return-object class="pt-2">
        <template v-slot:prepend="{ item, open }">
            <v-icon :color="iconColor(item)">
                {{ icon(item, open) }}
            </v-icon>
        </template>
        <template v-slot:label="{ item, active }">
            <v-radio-group v-model="computedCheckbox" hide-details v-if="isKnowledgeContentType(item) === 'FOLDER'">
                <v-radio hide-details :value="item" :key="item.id" :label="item.name" :disabled="isDisabled(item)" :ripple="false" />
            </v-radio-group>
            <span
                v-else
                :class="{
                    'primary--text': active,
                    'no-highlight': true,
                    'truncate-tree-item': true
                }"
            >
                {{ item.name || item.title }}
            </span>
        </template>
    </v-treeview>
</template>

<script>
import KnowledgeContentMixin from '../Mixins/KnowledgeContentMixin';
export default {
    name: 'knowledge-content-folder-selector',
    mixins: [KnowledgeContentMixin],
    props: {
        tree: {
            type: Array,
            default: function () {
                return this.getTree;
            }
        },
        value: {
            type: Object,
            default: () => ({})
        },
        disabledFolders: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        computedCheckbox: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        isDisabled({ id: folderId }) {
            return this.disabledFolders.map(({ id }) => id).includes(folderId);
        },
        iconColor(item) {
            if (item && item.state && item.state.stateName) {
                switch (item.state.stateName) {
                    case 'APPROVED':
                        return 'success';
                    case 'PENDING':
                        return 'warning';
                    case 'DECLINED':
                        return 'error';
                }
            }
            return '';
        },
        icon(item, open) {
            if (item.name) {
                return open && item.children && item.children.length > 0 ? 'mdi-folder-open-outline' : 'mdi-folder-outline';
            }
            return 'mdi-file';
        }
    }
};
</script>

<style scoped>
.truncate-tree-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.v-treeview {
    height: 100%;
}
.v-input--selection-controls {
    margin-top: 0;
}
</style>
